import { temAcesso } from '@/shared/auth/temAcesso'

const ItemDespesa = () => import('./ItemDespesa.vue')

export default {
    path: 'itensdespesa/:despesaItemId',
    name: 'DespesasGerais_Requisitantes_ItensDespesa_Detalhar',
    component: ItemDespesa,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-REQ-00')) {
            next()
        }
    } 
}